import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiHeroOneHalfImage' })(
  ({ breakpoints, type, typography }) => ({
    heroContainer: {
      marginTop: typography.pxToRem(0),
    },
    heroSection: {
      aspectRatio: '1440 / 908',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        maxHeight: typography.pxToRem(250),
      },
    },
    heroTextContainer: {
      margin: 'auto',
      display: 'flow-root',
      alignItems: 'center',
      paddingLeft: typography.pxToRem(30),
      paddingRight: typography.pxToRem(30),
      maxHeight: typography.pxToRem(480),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingLeft: typography.pxToRem(20),
        alignItems: 'unset',
        paddingTop: typography.pxToRem(32),
        paddingBottom: typography.pxToRem(48),
      },
    },
    heroTitle: {
      ...type['64_medium'],
      textWrap: 'pretty',
      paddingBottom: typography.pxToRem(20),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['44_medium'],
      },
    },
    heroBody: {
      ...type['20_regular'],
      paddingBottom: typography.pxToRem(20),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['16_medium'],
      },
    },
    heroButtom: {
      paddingBottom: typography.pxToRem(20),
    },
  })
);

export default useStyles;
